export function convertLocationPrecision(location: string | number) {
  if (Number.isNaN(Number(location))) {
    return 0;
  }

  return Number(location).toPrecision(8);
}
